// Tracking centralizado de cliques no WhatsApp (GA4 / Google Ads)
// GA4 ativo via gtag.js (G-BRN2N7TGGD) no index.html.
// Google Ads: quando o ID de conversão (AW-...) for fornecido, preencher
// ADS_CONVERSION_SEND_TO abaixo no formato "AW-XXXXXXXXX/rotulo".
// Deduplicação: um mesmo click não dispara 2x em curto intervalo (300ms).

const ADS_CONVERSION_SEND_TO = null; // ex: "AW-123456789/AbC-dEfGhI"

let lastClickAt = 0;
let lastContext = "";

export const trackWhatsAppClick = (context = "unknown", extra = {}) => {
  const now = Date.now();
  if (context === lastContext && now - lastClickAt < 300) return;
  lastClickAt = now;
  lastContext = context;

  if (typeof window === "undefined") return;

  const payload = {
    event_category: "contato",
    event_action: "whatsapp",
    event_label: context,
    click_id: (window.crypto && window.crypto.randomUUID) ? window.crypto.randomUUID() : `${now}-${Math.random()}`,
    page_path: window.location.pathname + window.location.hash,
    ...extra,
  };

  // GA4 (gtag.js) — evento whatsapp_click
  if (typeof window.gtag === "function") {
    window.gtag("event", "whatsapp_click", payload);

    // Google Ads — conversão (ativar quando ADS_CONVERSION_SEND_TO estiver definido)
    if (ADS_CONVERSION_SEND_TO) {
      window.gtag("event", "conversion", { send_to: ADS_CONVERSION_SEND_TO });
    }
  }

  // dataLayer — compatibilidade futura com GTM
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event: "whatsapp_click", ...payload });
};
